var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostsFilterEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5C3.5 4.72386 3.72386 4.5 4 4.5H6C6.27614 4.5 6.5 4.72386 6.5 5C6.5 5.27614 6.27614 5.5 6 5.5H4C3.72386 5.5 3.5 5.27614 3.5 5Z",
    fill: "#E20A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.5C5.27614 3.5 5.5 3.72386 5.5 4V6C5.5 6.27614 5.27614 6.5 5 6.5C4.72386 6.5 4.5 6.27614 4.5 6V4C4.5 3.72386 4.72386 3.5 5 3.5Z",
    fill: "#E20A57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6214 3.51492C11.8893 3.5819 12.0522 3.85337 11.9852 4.12126L11.4852 6.12126C11.4182 6.38916 11.1467 6.55204 10.8789 6.48507C10.611 6.41809 10.4481 6.14663 10.515 5.87873L11.015 3.87873C11.082 3.61083 11.3535 3.44795 11.6214 3.51492Z",
    fill: "#E20A57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5C17.5 4.72386 17.7239 4.5 18 4.5H20C20.2761 4.5 20.5 4.72386 20.5 5C20.5 5.27614 20.2761 5.5 20 5.5H18C17.7239 5.5 17.5 5.27614 17.5 5Z",
    fill: "#E20A57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3.5C19.2761 3.5 19.5 3.72386 19.5 4V6C19.5 6.27614 19.2761 6.5 19 6.5C18.7239 6.5 18.5 6.27614 18.5 6V4C18.5 3.72386 18.7239 3.5 19 3.5Z",
    fill: "#E20A57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3536 8.64645C15.5488 8.84171 15.5488 9.15829 15.3536 9.35355L14.3536 10.3536C14.1583 10.5488 13.8417 10.5488 13.6464 10.3536C13.4512 10.1583 13.4512 9.84171 13.6464 9.64645L14.6464 8.64645C14.8417 8.45118 15.1583 8.45118 15.3536 8.64645Z",
    fill: "#E20A57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4852 12.3787C20.5522 12.6466 20.3893 12.9181 20.1214 12.9851L18.1214 13.4851C17.8535 13.552 17.582 13.3892 17.515 13.1213C17.4481 12.8534 17.611 12.5819 17.8789 12.5149L19.8789 12.0149C20.1467 11.948 20.4182 12.1108 20.4852 12.3787Z",
    fill: "#E20A57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 19C17.5 18.7239 17.7239 18.5 18 18.5H20C20.2761 18.5 20.5 18.7239 20.5 19C20.5 19.2761 20.2761 19.5 20 19.5H18C17.7239 19.5 17.5 19.2761 17.5 19Z",
    fill: "#E20A57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17.5C19.2761 17.5 19.5 17.7239 19.5 18V20C19.5 20.2761 19.2761 20.5 19 20.5C18.7239 20.5 18.5 20.2761 18.5 20V18C18.5 17.7239 18.7239 17.5 19 17.5Z",
    fill: "#E20A57"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39314 9.50789C7.55428 9.47893 7.71939 9.53069 7.83515 9.64645L14.3532 16.1645C14.4469 16.2582 14.4996 16.3854 14.4996 16.518C14.4996 16.7135 14.3856 16.8921 14.2079 16.9735L4.62891 21.3635C4.35019 21.4908 4.03861 21.5302 3.73708 21.4757C3.43555 21.4213 3.15785 21.2761 2.9412 21.0594C2.72454 20.8428 2.57927 20.5651 2.52486 20.2635C2.47046 19.962 2.5095 19.651 2.63677 19.3723L7.02705 9.79171C7.09525 9.64288 7.232 9.53686 7.39314 9.50789ZM7.63656 10.8621L3.54642 19.7877C3.54638 19.7878 3.54646 19.7876 3.54642 19.7877C3.50392 19.8809 3.49078 19.9851 3.50897 20.0859C3.52718 20.1869 3.5758 20.2798 3.6483 20.3523C3.72081 20.4248 3.81375 20.4734 3.91466 20.4916C4.01546 20.5098 4.11941 20.4968 4.21261 20.4543C4.21271 20.4543 4.21251 20.4544 4.21261 20.4543L13.1382 16.3638L7.63656 10.8621Z",
    fill: "#E20A57"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsFilterEvents);
export default __webpack_public_path__ + "static/media/posts-filter-events.8b4b3b48311d073d722427ea6dc59298.svg";
export { ForwardRef as ReactComponent };